"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Video = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _uuid = require("uuid");
var _VideoContext = require("./contexts/VideoContext");
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var Video = function Video(props) {
  var _a = props.id,
    id = _a === void 0 ? (0, _uuid.v4)() : _a,
    src = props.src,
    _b = props.width,
    width = _b === void 0 ? 720 : _b,
    _c = props.height,
    height = _c === void 0 ? 405 : _c,
    _d = props.config,
    config = _d === void 0 ? {} : _d,
    onReady = props.onReady,
    onEvent = props.onEvent,
    children = props.children;
  var handleOnReady = (0, _react.useCallback)(function () {
    if (typeof onReady === 'function') {
      onReady();
    }
  }, [onReady]);
  var handleOnEvent = (0, _react.useCallback)(function (event) {
    if (typeof onEvent === 'function') {
      onEvent(event);
    }
  }, [onEvent]);
  var context = (0, _react.useMemo)(function () {
    return {
      id: id,
      src: src,
      width: width,
      height: height,
      config: config,
      onReady: handleOnReady,
      onEvent: handleOnEvent
    };
  }, [id, src, width, height, config, handleOnReady, handleOnEvent]);
  return (0, _jsxRuntime.jsx)(_VideoContext.VideoContext.Provider, __assign({
    value: context
  }, {
    children: children
  }));
};
exports.Video = Video;
Video.displayName = 'Video';
var _default = Video;
exports.default = _default;